import { createFiltersReducer, LICENSING_TYPE } from '../utils';
import { ACTIONS_PREFIX } from '../actions/licensesFilters';

const initialFiltersState = {
    searchData: '',
    users: [],
    offices: [],
    resourceOwner: [],
    strict: false,
    officeState: 2,
    resourceOwnerStrict: false,
    resourceOwnerState: 2,
    isOrdered: null,
    devices: [],
    projects: [],
    licenseType: '',
    licenseTypeId: '',
    licenseTypes: [],
    licenseTypeStrict: false,
    licenseVerifyKind: '',
    licensingType: LICENSING_TYPE.allLicenses,
    deliveryDateFrom: null,
    deliveryDateTo: null,
    expirationDateFrom: null,
    expirationDateTo: null,
    licenseManufacturers: [],
    licenseTitles: [],
    licenseNameParts: [],
    productTitleLicenseIds: [],
    licenseIds: [],
    pageNumber: 1,
    sortBy: 'licenseManufacturerName',
    sortOrder: 'asc',
    isAppliedFilter: false,
    isFreeLicense: null,
    freeLicense: {
        yes: false,
        no: false
    }
};

const initialState = {
    currentFilters: {
        ...initialFiltersState
    },
    appliedFilters: {
        ...initialFiltersState
    }
};

const licenseFiltersReducer = createFiltersReducer(ACTIONS_PREFIX, initialState);
export default licenseFiltersReducer;
